"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FDSUserStore = _interopRequireDefault(require("./FDS-UserStore.js"));

var _FDSWallet = _interopRequireDefault(require("./FDS-Wallet"));

var _FDSUtils = _interopRequireDefault(require("./FDS-Utils.js"));

var _FDSCrypto = _interopRequireDefault(require("./FDS-Crypto.js"));

var _FDSMail = _interopRequireDefault(require("./FDS-Mail.js"));

var _FDSSwarm = _interopRequireDefault(require("./FDS-Swarm.js"));

var _FDSSwarmStore = _interopRequireDefault(require("./FDS-SwarmStore.js"));

var _FDSFaucet = _interopRequireDefault(require("./FDS-Faucet"));

var _FDSTx = _interopRequireDefault(require("./FDS-Tx"));

var _ENSRegistry = _interopRequireDefault(require("./abi/ENSRegistry.json"));

var _FDSMultibox = _interopRequireDefault(require("./FDS-Multibox.js"));

var _FDSENS = _interopRequireDefault(require("./FDS-ENS2.js"));

var _FDSTrace = _interopRequireDefault(require("./FDS-Trace"));

var _ethEnsNamehash = _interopRequireDefault(require("eth-ens-namehash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

class FDSAccount {
  /**
   * Constructs account
   * @param {any} config settings
   */
  constructor(config) {
    this.config = config;
    this.UserStore = new _FDSUserStore.default(config, this);
    this.Store = new _FDSSwarm.default(config, this);
    this.SwarmStore = new _FDSSwarmStore.default(config, this);
    this.Mail = new _FDSMail.default(config, this);
    this.Tx = new _FDSTx.default(config, this);
    this.web3 = this.config.web3;
    this.faucet = new _FDSFaucet.default(config.faucetAddress);
  }
  /**
   * @returns {any} all Users
   */


  getAll(walletVersion) {
    return this.UserStore.getAll(walletVersion);
  }
  /**
   * Check if mailbox is valid
   * @isMailboxNameValid
   * check to see if name conforms to subdomain restrictions
   * @param {any} mailboxName name
   * @returns {boolean} is mailbox valid
   */


  isMailboxNameValid(mailboxName) {
    if (mailboxName === undefined || mailboxName === false) return false;
    var pattern = /^[a-z0-9_-]*$/;
    var matches = mailboxName.match(pattern);
    var pattern2 = /^[A-Z]*$/;
    var matches2 = mailboxName.match(pattern2);

    if (mailboxName.length < 83 && mailboxName.length > 3 && matches !== null && matches.length > 0 && matches2 === null) {
      return true;
    } else {
      return false;
    }
  }
  /**
   * Check if mailbox name is available
   * @isMailboxNameAvailable
   * @param {any} mailboxName name
   * @returns {boolean} is subdomain available
   */


  isMailboxNameAvailable(subdomain) {
    var _this = this;

    return _asyncToGenerator(function* () {
      var node = _ethEnsNamehash.default.hash(subdomain + '.' + _this.config.ensConfig.domain); //no account exists at this point, so can't use the FDSContract instance


      var ENS = _this.Tx.getContract(false, _ENSRegistry.default.abi, _this.config.ensConfig.registryAddress);

      var owner = yield ENS.call('owner', [node]);
      return owner === '0x0000000000000000000000000000000000000000';
    })();
  }
  /**
   * Creates an FDS account with associated ENS name and stores the account info in localstorage.
   * @createSubdomain
   * @param {string} subdomain name
   * @param {string} password password
   * @param {any} feedbackMessageCallback callback
   * @returns {Promise} promise
   */


  createWallet(password) {
    var dw = new _FDSWallet.default();
    return dw.generate(password);
  }

  createAndStoreAccount(subdomain, password, feedbackMessageCallback) {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      feedbackMessageCallback('creating wallet');
      var wallet = yield _this2.createWallet(password);
      feedbackMessageCallback('storing user');
      var user = yield _this2.UserStore.addUser(wallet.walletV3, subdomain);
      return _this2.unlockByAddress(user.wallet.address, password);
    })();
  }

  deployMultibox(user) {
    var _this3 = this;

    return _asyncToGenerator(function* () {
      return new _FDSMultibox.default(user, _this3.config).deploy();
    })();
  }

  getMultibox(user, subdomain) {
    var _this4 = this;

    return _asyncToGenerator(function* () {
      var ENS = new _FDSENS.default(user, _this4.config.ensConfig);
      var multiboxAddress = yield ENS.getMultihash(subdomain);
      return new _FDSMultibox.default(user, _this4.config).at(multiboxAddress);
    })();
  }

  addENS(user, subdomain, multihash) {
    var _this5 = this;

    return _asyncToGenerator(function* () {
      //, multihash = false){
      var confirmPk = false;

      if (multihash === false) {
        confirmPk = true;
      }

      var ENS = new _FDSENS.default(user, _this5.config.ensConfig);
      yield ENS.registerSubdomain(subdomain);
      yield ENS.setResolver(subdomain); //

      var content = '0x0000000000000000000000000000000000000000000000000000000000000000';
      var name = 'subdomain-hidden';
      yield ENS.setAll(subdomain, content, multihash, name, true);
      return true;
    })();
  } // creates account with ENS and multibox


  create(subdomain, password, feedbackMessageCallback) {
    var _this6 = this;

    return _asyncToGenerator(function* () {
      _FDSTrace.default.time("created account ".concat(subdomain));

      var isValid = _this6.isMailboxNameValid(subdomain);

      if (isValid === false) {
        throw new Error('account name is not valid.');
      } else {
        _FDSTrace.default.time("creating account ".concat(subdomain));

        feedbackMessageCallback('checking mailbox name is available');
        var isAvailable = yield _this6.isMailboxNameAvailable(subdomain);
        feedbackMessageCallback('mailbox name is available, creating account');

        if (isAvailable === true) {
          var mb;
          var user = yield _this6.createAndStoreAccount(subdomain, password, feedbackMessageCallback);
          console.info(user);
          var tokenName = _this6.config.tokenName;

          try {
            feedbackMessageCallback("account created, gifting you ".concat(tokenName, "! \u2764"));
            var fund = yield _this6.faucet.gimmie('0x' + user.wallet.address);
          } catch (error) {
            yield _this6.UserStore.delete(subdomain);
            throw new Error('could not fund account');
          }

          try {
            feedbackMessageCallback('deploying multibox');
            mb = yield _this6.deployMultibox(user);
          } catch (error) {
            yield _this6.UserStore.delete(subdomain);
            throw new Error('could not deploy multibox');
          } // try {
          //     feedbackMessageCallback('creating inbox');
          //     await mb.createPath('/shared/mail');
          // }
          // catch(error){
          //     throw new Error('could not create inbox');
          // }
          // try {


          feedbackMessageCallback('creating ENS subdomain');
          yield _this6.addENS(user, subdomain, mb.contractAddress); // }
          // catch(error){
          //     await this.UserStore.delete(subdomain);
          //     throw new Error('could not create ENS subdomain');
          // }
          // try {

          feedbackMessageCallback('initialising storage');
          yield _this6.SwarmStore.initContacts(user);
          yield _this6.SwarmStore.initStored(user); // }
          // catch(error){
          //     throw new Error('could not initialising storage');
          // }

          _FDSTrace.default.timeEnd("created account ".concat(subdomain));

          feedbackMessageCallback("created account ".concat(subdomain));
          return user;
        } else {
          throw new Error('account name is not available.');
        }
      }
    })();
  }
  /**
   * Ensure address has enough balance
   * @ensureHasBalance
   * @param {string} address to check
   * @returns {void}
   */


  ensureHasBalance(address) {
    var _this7 = this;

    return _asyncToGenerator(function* () {
      var intervalTime = 2000;
      var tries = 200;
      return new Promise((resolve, reject) => {
        var i = 0;
        var interval = setInterval(() => {
          i++;

          _this7.web3.eth.getBalance(address).then(balance => {
            console.log(i + '/ checking: ' + address + ' balance: ' + balance);

            if (i > tries) {
              clearInterval(interval);
              reject(false);
              return;
            }

            if (parseInt(balance) > 0) {
              clearInterval(interval);
              resolve(true);
            }
          });
        }, intervalTime);
      });
    })();
  }
  /**
   * Gets subdomina
   * @get
   * @param {any} subdomain name
   * @returns {User} User
   */


  get(subdomain) {
    var user = this.UserStore.get(subdomain);

    if (user === false) {
      throw new Error("".concat(subdomain, " account does not exist locally, please import it."));
    }

    return user;
  }
  /**
   * Unlock subdomain
   * @unlock
   * @param {any} subdomain name
   * @param {any} password to use
   * @returns {User} user
   */


  unlockByAddress(address, password) {
    var _this8 = this;

    return _asyncToGenerator(function* () {
      var user = _this8.UserStore.getByAddress(address);

      yield user.syncNonce();

      if (user === false) {
        throw new Error("".concat(address, " account does not exist locally, please import it."));
      }

      var wallet = new _FDSWallet.default();
      return wallet.fromJSON(user.wallet, password).then(wallet => {
        user.address = wallet.address;
        user.publicKey = wallet.publicKey;
        user.privateKey = wallet.privateKey;
        return user;
      });
    })();
  }
  /**
   * Unlock subdomain
   * @unlock
   * @param {any} subdomain name
   * @param {any} password to use
   * @returns {User} user
   */


  unlock(subdomain, password) {
    var _this9 = this;

    return _asyncToGenerator(function* () {
      var user = _this9.get(subdomain);

      yield user.syncNonce();
      var wallet = new _FDSWallet.default();
      return wallet.fromJSON(user.wallet, password).then(wallet => {
        user.address = wallet.address;
        user.publicKey = wallet.publicKey;
        user.privateKey = wallet.privateKey;
        return user;
      });
    })();
  }
  /**
   * Restore wallet from JSON
   * @restore
   * @param {string} subdomain name
   * @param {string} walletJSONString json
   * @returns {User} user
   */


  restore(subdomain, walletJSONString) {
    return this.UserStore.restore(subdomain, walletJSONString);
  }
  /**
   * Restore from private key
   * @param {any} subdomain domain to use
   * @param {any} password password to use
   * @param {any} privateKey  private key without 0x
   * returns {any} stored wallet
   */


  restoreFromPrivateKey(subdomain, password, privateKey) {
    return new _FDSWallet.default().encrypt(privateKey, password).then(walletJSONString => {
      this.UserStore.restore(subdomain, walletJSONString);
      return this.unlock(subdomain, password);
    });
  }
  /**
   * Restore wallet from file
   * @restoreFromFile
   * @param {string} file to restore
   * @returns {any} restored wallet
   */


  restoreFromFile(file) {
    var match = file.name.match(/fds-wallet-(.*)-backup/);

    if (match.length === 2) {
      var subdomain = match[1];
    } else {
      throw new Error('file name should be in the format fds-wallet-subdomain-backup');
    }

    return _FDSUtils.default.fileToString(file).then(walletJSON => {
      this.restore(subdomain, walletJSON);
    });
  }

  delete(subdomain) {
    return this.UserStore.delete(subdomain);
  }

}

var _default = FDSAccount;
exports.default = _default;
module.exports = exports.default;